module.exports = __webpack_public_path__ + "static/media/Receipt_Template_2.12117b29.png";